<template>
  <div class="recharge">
    <div class="recharge-title">
      我的钱包 /
      <span>余额充值</span>
    </div>
    <div class="recharge-payment-mode">
      <div class="recharge-price">
        <div class="recharge-money">充值金额：</div>
        <el-input
          class="default-input"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          v-model="amount"
          placeholder="请输入充值金额"
        ></el-input>
        <div class="quick">
          <button @click="amount = 500">500</button>
          <button @click="amount = 1000">1000</button>
          <button @click="amount = 2000">2000</button>
          <button @click="amount = 3000">3000</button>
          <button @click="amount = 5000">5000</button>
        </div>
      </div>
      <div class="recharge-payment-mode-title">支付方式：</div>
      <div class="disanfang">
        <div
          v-if="isShow('ALIPAY')"
          :class="{ selected: payMode[0].selected }"
          @click="payMethod('ALIPAY')"
        >
          <svg class="icon icona_xiadan_weixin" aria-hidden="true">
            <use xlink:href="#icona_xiadan_weixin" />
          </svg>
          支付宝账户
        </div>
        <div
          v-if="isShow('WECHAT')"
          :class="{ selected: payMode[1].selected }"
          @click="payMethod('WECHAT')"
        >
          <svg class="icon icona_xiadan_zhifubao" aria-hidden="true">
            <use xlink:href="#icona_xiadan_zhifubao" />
          </svg>
          微信账户
        </div>
      </div>
      <el-button v-if="payWay == 'ALIPAY'" class="lijizhifu" @click="recharge()"
        >立即支付</el-button
      >
    </div>
    <img class="wexcode" :src="imgUrl" v-show="payWay == 'WECHAT'" alt />
    <div v-if="payWay == 'WECHAT'" class="wexcode_text" style="margin-top: -21px;">
      请使用
      <b>微信</b>扫码支付
    </div>
    <!-- <img class="wexcode" src alt /> -->

    <el-dialog
      title="订单支付"
      :visible.sync="orderPay"
      width="30%"
      class="zfmima"
    >
      <div>是否已支付成功？</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="orderPay = false">取 消</el-button>
        <el-button type="primary" @click="paySuccess()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="订单支付打开失败"
      :visible.sync="ispayHtml"
      width="423"
      class="payHtmlNo"
      @closed="payHtmlClose"
    >
      <div class="payHtmlNo-main">
        <div class="payHtmlNo-note">请复制下方链接在新窗口打开进行支付</div>
        <div class="payHtmlNo-url">{{ pathStr }}</div>
        <div class="payHtmlNo-copy" @click="copyUrl">复制链接</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="ispayHtml = false">取消</el-button>
        <el-button type="primary" @click="ispayHtml = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {
      zhifubao: true,
      wechat: false,
      payMode: [
        { selected: true, name: "ALIPAY" },
        { selected: false, name: "WECHAT" }
      ],
      payWay: "ALIPAY", // 支付方式，默认支付宝
      amount: "",
      imgUrl: "",
      rechargeOrderNo: "",
      myerval: "",
      orderPay: false,
      baseApl: process.env.VUE_APP_BASE_API,

      ispayHtml: false,
      pathStr: "",
      orderPayWay: []
    };
  },
  mounted() {
    // 获取可用支付方式
    this.$fetch(`/common/platform/get_pay_way`).then(res => {
      if (res.code == 0) {
        if (res.data.orderPayWay.indexOf("WALLET") != -1) {
          this.orderPayWay = res.data.orderPayWay.filter(i => {
            return i != "WALLET";
          });
        }
        // 设置默认支付方式
        this.payMethod(res.data.cashOutWay[0]);
      } else {
        this.$message(res.message);
      }
    });
  },
  methods: {
    // 是否显示
    isShow(item) {
      if (this.orderPayWay.indexOf(item) != -1) {
        return true;
      } else {
        return false;
      }
    },
    // 支付方式
    payMethod(item) {
      this.$message.closeAll();
      if (item == "ALIPAY") {
        this.payWay = item;
        for (let i of this.payMode) {
          i.selected = false;
          if (item == i.name) {
            i.selected = true;
          }
        }
      }

      if (item == "WECHAT") {
        if (this.amount == "") {
          this.$message("请先输入要充值的金额");
          return;
        }
        this.payWay = item;
        for (let i of this.payMode) {
          i.selected = false;
          if (item == i.name) {
            i.selected = true;
          }
        }
        this.recharge();
      }
    },
    // 获取充值订单信息
    getRechargeOrder() {
      this.$fetch(`/order//api/order/charge_info`, {
        orderNo: this.rechargeOrderNo
      }).then(res => {
        if (res.data.status == "SUCCESS") {
          clearInterval(this.myerval);
          this.$message({
            message: "充值成功",
            type: "success"
          });
          setTimeout(() => {
            this.$router.push({ path: "/user/wallet" });
          }, 500);
        }
      });
    },
    // 充值
    recharge() {
      let _this = this;
      this.$message.closeAll();
      if (this.amount == "") {
        this.$message("请先输入要充值的金额");
        return;
      }
      this.$fetch(`/order/api/order/charge`, {
        amount: this.amount,
        payWay: this.payWay
      }).then(res => {
        if (this.payWay == "ALIPAY") {
          let newPageHtml = window.open("about:blank");
          localStorage.setItem("payHtml", res.data.html);

          this.pathStr = process.env.VUE_APP_URL + "/pay";
          if (newPageHtml) {
            newPageHtml.location = this.pathStr;

            this.orderPay = true;
          } else {
            this.ispayHtml = true;
          }
        }
        if (this.payWay == "WECHAT") {
          this.imgUrl = res.data.url;
          this.rechargeOrderNo = res.data.orderNo;
          clearInterval(this.myerval);
          _this.myerval = setInterval(() => {
            _this.getRechargeOrder();
          }, 2000);
        }
      });
    },
    // 支付未打开新页面情况下 dialog 关闭的回调
    payHtmlClose() {
      let timer = setTimeout(() => {
        this.orderPay = true;
        clearTimeout(timer);
      }, 300);
    },
    // 立即复制
    copyUrl(e) {
      this.$message.closeAll();
      const clipboard = new Clipboard(e.target, { text: () => this.pathStr });
      clipboard.on("success", e => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message.warning("该浏览器不支持自动复制，请手动复制");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    // 支付成功
    paySuccess() {
      this.$router.push({ path: "/user/wallet" });
    }
  }
};
</script>
<style lang="scss" scoped>
.recharge {
  // height: 449px;
  background: #ffffff;
  padding: 24px 20px 40px 20px;
  .wexcode {
    width: 200px;
    height: 200px;
    margin-left: calc(50% - 100px);
  }
  .wexcode_text{
    // margin-left: calc(50% - 100px);
    text-align: center;
  }
  .recharge-title {
    color: #5e6066;
    font-size: 18px;
    span {
      color: #909399;
    }
  }
  .recharge-payment-mode {
    width: 392px;
    margin: 0 auto;
    margin-top: 40px;
    .recharge-money {
      margin-bottom: 16px;
    }
    .recharge-payment-mode-title {
      color: #5e6066;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      margin-top: 42px;
    }
    .disanfang {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      & > div {
        width: 190px;
        height: 100px;
        background: rgba(249, 250, 250, 1);
        border-radius: 2px;
        border: 1px solid rgba(206, 212, 219, 1);
        font-size: 16px;
        padding: 22px 20px;
        color: #5e6066;
        display: flex;
        align-items: center;
        cursor: pointer;
        .icon {
          width: 56px;
          height: 56px;
          color: #b4b7bc;
          margin-right: 8px;
        }
      }
      .selected {
        background: rgba(243, 245, 253, 1);
        border: 1px solid rgba(52, 85, 211, 1);
        color: #2f3133;
        .icon {
          color: #3455d3;
        }
      }
    }
    .recharge-price {
      // margin-top: 42px;
      .quick {
        margin-top: 9px;
        display: flex;
        & > button {
          width: 60px;
          height: 32px;
          border-radius: 2px;
          border: 1px solid rgba(190, 192, 198, 1);
          padding: 10px 0;
          color: #5e6066;
          font-size: 12px;
          margin-right: 5px;
          line-height: 1;
          cursor: pointer;
          text-align: center;
          background: #ffffff;
          outline: none;
        }
        & > button:hover,
        & > button:focus {
          border-color: #3455d3;
          color: #3455d3;
        }
      }
    }
    .lijizhifu {
      width: 190px;
      height: 30px;
      background: rgba(52, 85, 211, 1);
      border-radius: 2px;
      border-color: #3455d3;
      color: #ffffff;
      font-size: 14px;
      padding: 0;
      margin-top: 24px;
    }
  }
  &/deep/ .zfmima {
    .el-dialog__body {
      padding: 5px 12px !important;
      position: relative;
      .iconz_toast_warn {
        color: #3455d3;
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
    }
    .el-dialog__footer {
      padding: 10px 12px 20px;
      margin-top: 10px;
    }
    .el-dialog__title {
      font-weight: bold;
    }
    .el-button {
      border-radius: 2px;
    }
    .el-button--primary {
      background: #3455d3;
      color: #fff;
      border-color: #3455d3;
      width: 60px;
      height: 28px;
      padding: 0 !important;
    }
    .el-button--primary:hover {
      background: #2c4abb;
      border-color: #2c4abb;
    }
    .el-button--default:hover {
      color: #3455d3;
      border-color: #3455d3;
      background: #fff;
    }
    .el-button--default {
      color: #bec0c6;
      border-color: #bec0c6;
      width: 60px;
      height: 28px;
      padding: 0 !important;
    }
    .el-dialog__headerbtn:hover .el-dialog__close {
      color: #3455d3;
    }
  }
}
</style>

<style lang="scss">
.payHtmlNo {
  .el-dialog {
    width: 423px !important;
    border-radius: 2px;
    font-family: MicrosoftYaHei;
    .el-dialog__header {
      padding: 24px 45px 0 45px;
      font-size: 14px;
      line-height: 14px;
      font-weight: 700;
      color: #2f3133;
    }
    .el-dialog__body {
      margin-top: 12px;
      padding: 0 45px;
      .payHtmlNo-main {
        .payHtmlNo-note {
          height: 12px;
          font-size: 12px;
          color: #909399;
          line-height: 12px;
        }
        .payHtmlNo-url {
          margin: 24px 0 0 0;
          font-size: 14px;
          color: #5e6066;
          line-height: 14px;
        }
        .payHtmlNo-copy {
          margin: 12px 0 0 0;
          font-size: 12px;
          color: #3455d3;
          line-height: 12px;
          border: none;
          background: #fff;
          cursor: pointer;
        }
      }
    }

    .el-dialog__footer {
      padding: 26px 45px 24px 45px;
      .el-button {
        padding: 8px 18px;
        font-size: 12px;
        color: #5e6066;
        border: 1px solid #bec0c6;
        border-radius: 2px;
      }
      .el-button--primary {
        color: #fff;
        background: #3455d3;
        border-color: #3455d3;
      }
    }
  }
}
</style>
